import React, { useState, useEffect, useContext } from 'react';
import ImageFadeIn from 'react-image-fade-in';
import logo from '../../images/boomer.svg';
import styles from './MobileOverlay.module.scss';
import { AuthContext } from '../../services/auth/AuthProvider';
import { useNavigate } from '@reach/router';

const useIsMobile = (maxWidth = 768) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= maxWidth);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= maxWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [maxWidth]);

    return isMobile;
};

export const MobileOverlay = () => {
    const isMobile = useIsMobile();
    const [overlayDismissed, setOverlayDismissed] = useState(false);
    const auth = useContext(AuthContext);

    const redirectToLogin = () => {
        if (auth.currentUser) {
            window.location.href = '/logout';
        }
        setOverlayDismissed(true);
    };

    if (!isMobile) return null;
    if (overlayDismissed) return null;

    return (
        <div className={styles.overlayWrapper}>
            <div className={styles.overlayContent}>
                <ImageFadeIn
                    width='140'
                    height='140'
                    src={logo}
                    alt='Go Apps Logo'
                />

                <h1>Welcome to BoomHub!</h1>
                <h3>
                    For the best experience, please use BoomHub on a tablet or
                    desktop device
                </h3>
                <h3>
                    Some features may not work as expected in portrait mode of
                    mobile phones
                </h3>

                <button
                    onClick={() => setOverlayDismissed(true)}
                    className={`${styles.overlayButton} ${styles.overlayButtonGreen}`}
                >
                    Continue Anyway
                </button>

                <button
                    onClick={() => redirectToLogin()}
                    className={`${styles.overlayButton} ${styles.overlayButtonPurple}`}
                >
                    Back
                </button>
            </div>
        </div>
    );
};
